<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-8">
                <card-component titulo="INVENTARIO FÍSICO" componente="null" usuario="null">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col-3 mb-3">
                                <input-container-component titulo="Ano Inventário">
                                    <select name="anoCaixa" class="form-control" id="anoCaixa" v-model="ano_inv_fisico"
                                        @change="carregaInventario">
                                        <option value="2026">2026</option>
                                        <option value="2027">2027</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3">
                                <input-container-component titulo="Mês Inventário">
                                    <select name="mesCaixa" class="form-control" id="mesCaixa" v-model="mes_inv_fisico"
                                        @change="carregaInventario">
                                        <option value="01">Janeiro</option>
                                        <option value="02">Fevereiro</option>
                                        <option value="03">Março</option>
                                        <option value="04">Abril</option>
                                        <option value="05">Maio</option>
                                        <option value="06">Junho</option>
                                        <option value="07">Julho</option>
                                        <option value="08">Agosto</option>
                                        <option value="09">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3" v-if="userJson.nivel_acesso == 'adm'">
                                <input-container-component titulo="Caps Inventário">
                                    <select name="capsInv" class="form-control" id="capsInv" v-model="caps_inv_fisico"
                                        @change="carregaInventario">
                                        <option value="1">Sede</option>
                                        <option value="2">N. Tempo</option>
                                        <option value="5">David Capstrano</option>
                                        <option value="6">Estacao</option>
                                        <option value="7">Integracao</option>
                                        <option value="9">Toninho</option>
                                        <option value="10">Esperanca</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3" v-if="userJson.nivel_acesso != 'adm'">
                                <a v-if="ano_inv_fisico && mes_inv_fisico" :href="'/inventario-fisico-pdf/'+ano_inv_fisico +'-'+ mes_inv_fisico+'/'+userJson.caps_id" target="_blank" class="btn btn-primary">Acessar</a>
                            </div>
                            <div class="col-3 mb-3" v-else>
                                <a v-if="ano_inv_fisico && mes_inv_fisico && caps_inv_fisico" :href="'/inventario-fisico-pdf/'+ano_inv_fisico +'-'+ mes_inv_fisico+'/'+caps_inv_fisico" target="_blank" class="btn btn-primary">Acessar</a>
                            </div>
                        </div>
                    </template>
                    <template v-slot:rodape>
                    </template>
                </card-component>
            </div>
            <div class="col-md-8">
                <card-component titulo="INVENTARIO">
                    <template v-slot:conteudo>
                        <div v-for="obj in somaCentroCusto">
                            Soma centro de custo <b>{{ obj }}</b>
                        </div>
                        <div>Soma total geral: <b>{{ somaGeral }}</b></div>
                    </template>
                    <template v-slot:rodape>
                    </template>
                </card-component>
            </div>
            <div class="col-md-8">
                <card-component titulo="Lista dos pacientes">
                    <template v-slot:conteudo>
                        <div class="row">
                            <div class="col-3 mb-3">
                                <input-container-component titulo="Ano Inventário">
                                    <select name="anoCaixa" class="form-control" id="anoCaixa" v-model="ano_inv"
                                        @change="carregaInventario">
                                        <option value="2025">2025</option>
                                        <option value="2026">2026</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3">
                                <input-container-component titulo="Mês Inventário">
                                    <select name="mesCaixa" class="form-control" id="mesCaixa" v-model="mes_inv"
                                        @change="carregaInventario">
                                        <option value="01">Janeiro</option>
                                        <option value="02">Fevereiro</option>
                                        <option value="03">Março</option>
                                        <option value="04">Abril</option>
                                        <option value="05">Maio</option>
                                        <option value="06">Junho</option>
                                        <option value="07">Julho</option>
                                        <option value="08">Agosto</option>
                                        <option value="09">Setembro</option>
                                        <option value="10">Outubro</option>
                                        <option value="11">Novembro</option>
                                        <option value="12">Dezembro</option>
                                    </select>
                                </input-container-component>
                            </div>
                            <div class="col-3 mb-3" v-if="userJson.nivel_acesso == 'adm'">
                                <input-container-component titulo="Caps Inventário">
                                    <select name="capsInv" class="form-control" id="capsInv" v-model="caps_inv"
                                        @change="carregaInventario">
                                        <option value="1">Sede</option>
                                        <option value="2">N. Tempo</option>
                                        <option value="5">David Capstrano</option>
                                        <option value="6">Estacao</option>
                                        <option value="7">Integracao</option>
                                        <option value="9">Toninho</option>
                                        <option value="10">Esperanca</option>
                                    </select>
                                </input-container-component>
                            </div>
                        </div>
                        <table class="table table-success table-striped table-hover">
                            <thead>
                                <tr style="font-size: 12px;"><!-- class="text-uppercase" -->
                                    <th>Nome</th>
                                    <th>Centro Custo</th>
                                    <th>Saldo</th>
                                </tr>
                            </thead>
                            <tbody style="font-size: 12px;">
                                <tr v-for="obj in inventario">
                                    <td>{{ obj.nome_paciente }}</td>
                                    <td>{{ obj.centro_custo_paciente }}</td>
                                    <td>{{ obj.saldo | formatarValorBRGlobal }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                    <template v-slot:rodape>
                    </template>
                </card-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['user'],
    data() {
        return {
            urlBase: 'https://contasmoradores.candido.org.br/api/v1/paciente-cx',
            urlFiltro: '',
            inventario: [],
            busca: { nome: '' },
            somaGeral: '',
            somaCentroCusto: [],
            ano_inv: new Date().getFullYear(),
            mes_inv: '0' + (new Date().getMonth() + 1),
            caps_inv: '',
            ano_inv_fisico: '',
            mes_inv_fisico: '',
            caps_inv_fisico: '',
        }
    },
    methods: {
        carregaInventario() {
            let url = ''
            if (this.ano_inv != '' && this.mes_inv != '') {
                if (this.userJson.nivel_acesso != 'adm') { 
                    url = 'https://contasmoradores.candido.org.br/inventario/' + this.userJson.caps_id + '/' + this.ano_inv + '/' + this.mes_inv
                } else if (this.caps_inv != '') {
                    url = 'https://contasmoradores.candido.org.br/inventario/' + this.caps_inv + '/' + this.ano_inv + '/' + this.mes_inv
                } else {
                    return  
                }
 
                let config = {
                    headers: {
                        'Accept': 'application/json',
                        'Authorization': this.token
                    }
                }
                axios.get(url, config)
                    .then(response => {
                        this.inventario = response.data.inventario.sort((a, b) => {
                            return a.nome_paciente.localeCompare(b.nome_paciente);
                        }); 
                        this.somaCentroCusto = []
                        this.somaGeral = []
                        this.calculaSaldos()
                    })
                    .catch(errors => {
                    })
            }
        },
        calculaSaldos() {
            const agrupados = {};
            let somaTotalGeral = 0;

            this.somaCentroCusto = []; // limpar antes

            this.inventario.forEach(p => {
                const centro = p.centro_custo_paciente
                const saldo = parseFloat(p.saldo.replace(/\./g, '').replace(',', '.'))

                if (!agrupados[centro]) {
                    agrupados[centro] = 0
                }

                agrupados[centro] += saldo
                somaTotalGeral += saldo
            });

            for (const [centro, soma] of Object.entries(agrupados)) {
                this.somaCentroCusto.push(`${centro}: R$ ${soma.toFixed(2)}`)
            }

            this.somaGeral = `R$ ${somaTotalGeral.toFixed(2)}`
        }
    },
    mounted() {
        this.carregaInventario()
    },
    computed: {
        token() {
            let token = 'Bearer ' + document.cookie.split(';').find(indice => {
                return indice.includes('token=')
            }).split('=')[1]
            return token
        },

        userJson() {
            return JSON.parse(this.user);
        },
    },
}
</script>
<style>
.entrada td {
    color: green;
}

.saida td {
    color: red;
}
</style>